import { UAParser } from 'ua-parser-js';

// https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/toSorted
const MINIMUM_BROWSER_VERSIONS = {
  chrome: 110,
  edge: 110,
  firefox: 115,
  opera: 96,
  safari: 16,
  'chrome android': 110,
  'firefox android': 115,
  'opera android': 74,
  'safari ios': 16,
  'samsung internet': 21,
  'webview android': 110,
  'webview ios': 16,
  bun: 1,
  deno: 1.31,
  nodejs: 20,
} as const;

// ブラウザの互換性をチェックする関数（クライアントサイド版）
export function isBrowserCompatible(userAgent?: string): boolean {
  // サーバーサイドレンダリング中は常にtrueを返す
  // `window` might be missing when running in a non-browser environment.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (globalThis.window === undefined) {
    return true;
  }

  const resolvedUserAgent =
    userAgent ??
    // `navigator` is not available during SSR, so guard before accessing it.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    (globalThis.navigator ? globalThis.navigator.userAgent : '');
  const parser = new UAParser(resolvedUserAgent);
  const result = parser.getResult();

  const browserName = result.browser.name?.toLowerCase();
  const browserVersion = Number.parseFloat(result.browser.version ?? '0');
  const osName = result.os.name;
  const deviceType = result.device.type;

  // モバイルブラウザの判定
  if (deviceType === 'mobile' || osName === 'Android' || osName === 'iOS') {
    // Firefox Android
    if (browserName === 'firefox' && osName === 'Android') {
      return browserVersion >= MINIMUM_BROWSER_VERSIONS['firefox android'];
    }

    // Opera Android
    if (browserName === 'opera' && osName === 'Android') {
      return browserVersion >= MINIMUM_BROWSER_VERSIONS['opera android'];
    }

    // Safari iOS
    if ((browserName === 'safari' || browserName === 'mobile safari') && osName === 'iOS') {
      return browserVersion >= MINIMUM_BROWSER_VERSIONS['safari ios'];
    }

    // Chrome Android
    if (browserName === 'chrome' && osName === 'Android') {
      return browserVersion >= MINIMUM_BROWSER_VERSIONS['chrome android'];
    }

    // Samsung Internet
    if (browserName === 'samsung browser') {
      return browserVersion >= MINIMUM_BROWSER_VERSIONS['samsung internet'];
    }

    // WebView Android
    if (browserName === 'chrome webview' && osName === 'Android') {
      return browserVersion >= MINIMUM_BROWSER_VERSIONS['webview android'];
    }
  }

  // デスクトップブラウザの判定
  if (browserName && browserName in MINIMUM_BROWSER_VERSIONS) {
    const minVersion = MINIMUM_BROWSER_VERSIONS[browserName as keyof typeof MINIMUM_BROWSER_VERSIONS];
    return browserVersion >= minVersion;
  }

  // 不明なモバイルブラウザの場合は対応する
  return true;
}
